import { Injectable, Injector } from '@angular/core';
import { BaseService } from '@common-modules/shared/base.service';
import { DialogService } from '@common-modules/shared/dialogs/dialogs.service';
import { WlmNavKeys } from '@water-loss/features/navigation/wlm-nav-keys';
import { Observable } from 'rxjs';
import { HomePageService } from '../shared/services/home-page.service';

@Injectable({ providedIn: 'root' })
export class IntegrationUserService extends BaseService {
  private _entityUrl: string;

  constructor(
    injector: Injector,
    private readonly _homePageService: HomePageService,
    private readonly _dialogService: DialogService,
  ) {
    super(injector);
    this._entityUrl = `${this.apiUrl}/integration/user`;
  }

  /**
   * Ensure that an integrator user exists in the DB and, if it was just created, set integration mode.
   */
  ensureIntegrationSetup(continueCallback: () => void): void {
    this.getIfUserExists().subscribe({
      next: (exists) => {
        if (exists) {
          continueCallback();
        } else {
          this.create().subscribe({
            next: (created) => {
              this.setIntegrationHomePage().subscribe({
                next: () => continueCallback(),
                error: (e) => this.onAnyError(e, continueCallback),
              });
            },
            error: (e) => this.onAnyError(e, continueCallback),
          });
        }
      },
      error: (e) => this.onAnyError(e, continueCallback),
    });
  }

  private create(): Observable<boolean> {
    return this.httpCacheClient.post<boolean>(this._entityUrl, {});
  }

  private getIfUserExists(): Observable<boolean> {
    return this.httpCacheClient.get<boolean>(this._entityUrl);
  }

  private setIntegrationHomePage(): Observable<void> {
    return this._homePageService.change(WlmNavKeys.Integration);
  }

  private onAnyError = (error, continueCallback) => {
    this._dialogService.showErrorMessage(error);
    continueCallback();
  };
}
